<template>
<!-- Single post-->
    <section class="section section-lg bg-default">
      <b-alert :show="this.updateFailed" variant="danger" dismissible fade>Unexpected Error: Unable to update.</b-alert>
      <div class="container-wide">
         <div>
            <fieldset>
               <legend>Control Settings</legend>
               <br>
               <!--DESKTOP TABLE-->
               <table class="main-table">
                  <tr>
                     <td> <strong>Controller Name:</strong> </td>
                     <td> <strong>Description:</strong> </td>
                     <td> <strong>Last update by:</strong> </td>
                     <td> </td>
                  </tr>
                  <template v-for="(obj, index) in eowp.controlSetting">
                    <tr :key="index" v-if="obj.showItem">
                        <td class="baseline">{{obj.name}}</td>
                        <td class="baseline">{{obj.description}}</td>
                        <td class="baseline">{{obj.updatedBy}}</td>
                        <td class='alnright switch'>
                        <div class="switch_container">
                           <label class="switch">
                           <input type="checkbox" :checked="obj.status == 1 ? true: false"
                           @change="toggleSetting(obj)"/>
                           <span class="slider" :class="showToggleLoading(obj.id)"></span>
                           </label>
                        </div>
                        </td>
                    </tr>
                  </template>
                  <br/>
                </table>
                <!--MOBILE TABLE-->
                <table class='table table-condensed'>
                    <tbody v-for="(obj, index) in eowp.controlSetting" :key="index">
                    <tr>
                        <td class="td_mobile">
                            <p class="p_mobile"><strong>Controller Name: </strong> {{obj.name}}</p>
                        </td>
                        <td class='alnright medium_screen' rowspan="3"><div class="switch_container">
                           <label class="switch">
                           <input type="checkbox" :checked="obj.status == 1 ? true: false"
                           @change="toggleSetting(obj)"/>
                           <span class="slider" :class="showToggleLoading(obj.id)"></span>
                           </label></div>
                        </td>
                    </tr>
                    <tr>
                        <td class="td_mobile">
                            <p class="p_mobile"><strong>Description: </strong> {{obj.description}}</p>
                        </td>
                    </tr>
                    <tr>
                        <td class="td_mobile">
                            <p class="p_mobile"><strong>Last Update by: </strong> {{obj.updatedBy}}</p>
                        </td>
                    </tr>
                    <tr class="small_screen">
                        <td class="td_mobile_small">
                            <div class="switch_container">
                            <label class="switch">
                            <input type="checkbox" :checked="obj.status == 1 ? true: false"
                            @change="toggleSetting(obj)"/>
                            <span class="slider" :class="showToggleLoading(obj.id)"></span>
                            </label>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </fieldset>
            <div>
                <router-link to="/worker-management" class="custom-link">Sync Worker Management</router-link>
            </div>
            <div>
                <router-link to="/problematic-subscriptions" class="custom-link">Problematic Subscriptions</router-link>
            </div>
         </div>
      </div>
   </section>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.custom-link{
    color: #4e95a5;
    font-weight: 600;
}
div.container-wide{
  max-width: 2400px!important;
}
.section{
  padding-top: 100px!important;
  padding-bottom: 180px!important;
  text-align: center;

}
legend {
    font-size: 2.5rem !important;
}
.main-table, .main-table-mobile {
  margin-left: auto;
  margin-right: auto;
}
td {
  width: 13.5em;
  height: 2.5em;
  text-align: center;
}
.baseline{
    vertical-align: baseline;
}
.buttons{
    position: relative!important;
    display: flex!important;
    float: right!important;
    margin-top: 0px!important;
    margin-right: 10px!important;
    font-size: 12px!important;
    height: 30px!important;
    padding-inline: 20px;
    min-width: 60px!important;
}
.alnright { 
  text-align: right;
}
.alnleft, td{
  text-align: left;
}
.button-xs {
	line-height: 13px;
}
.switch{
    position: relative;
    display: inline-block;
    width: 70px;
    height: 35px;
    margin: 0 0px;
    vertical-align: middle;
}
.slider{
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;;
    background-color: #ccc;
    transition: .4s;
    border-radius: 34px;
}
.switch input{
    display: none;
}
.slider-loading{
    background-color: rgb(228, 214, 86) !important;
    transition: .2s !important;
}
.slider:before{
    position: absolute;
    content: " ";
    height: 25px;
    width: 25px;
    left: 5px;
    bottom: 5px;
    background-color: white;
    transition: 0.4s;
    border-radius: 25px;
}
input:checked ~ .slider{
    background-color: #1b7fdd;
}
input:checked ~ .slider:before{
    transform: translateX(35px);
    -webkit-transform: translateX(35px);
    -ms-transform: translateX(35px);
}
.page-loading-indicator > img {
    margin-top: 30px;
    width: 50px;
}
@media screen and (min-width: 936px) {
	.main-table {
		display: inline-table !important;
	}
	.table-condensed {
		display: none;
	}
}
@media screen and (max-width: 936px) {
	.main-table {
		display: none!important;
	}
	.table-condensed {
		display: inline-table;
	}
    .small_screen {
		display: none;
	}
}
@media screen and (max-width: 525px) {
	.medium_screen {
		display: none;
	}
    .small_screen{
        display: inherit;
    }
}
.td_mobile{
    width: 1.5em !important;

    text-align: left !important;
    height: 20px !important;
    padding-left: 38px !important;
}
.table-condensed tbody td{
    border-top: none !important;
}
.switch_container{
    vertical-align: middle;
    margin-right: 45px !important;
}
.td_mobile_small{
    width: 29.5em !important;
    text-align: right !important;
}
</style>

<script>
import { mapActions, mapGetters} from "vuex";
import UserModel from "../../../js/models/UserModel";
import { BAlert } from "bootstrap-vue";
import Utils from '../../../js/helpers/Utils';
import DialogMixin from '../../../js/helpers/mixins/DialogMixin';

export default {
    data(){
        return {
            pageLoadingIndicator: false,
            toggleButtonLoadingOwner: '',
            eowp: {
                controlSetting: {
                    id: '',
                    controlCode: '',
                    description: '',
                    name: '',
                    redirect: '',
                    status: '',
                    updatedBy: '',
                    checked: '',
                    rolesAllowed: [],
                    showItem: false
                },
                pageControlName: 'access_control_page'
            },
            updateFailed: false,
            authorizedUser: {
                verified: false,
                allowedRole: [1, 2]
            },
            userRoleId: ''
        }
    },
    async created(){
        //refresh the session details stored in storage
        await this.fetchSessionDetails(this.userSession);
        if(Utils.isEmpty(this.userSession) || Utils.isEmpty(this.userEmail)){
            this.$router.push("/products");
        }
        this.verifyControlPageAccess();

        let user = {
            sessionId: this.userSession,
            email: this.userEmail
        };

        let vm = this;
        this.fetchUserDetails(user).then(res => {
            vm.userRoleId = res.records.roleId;
        });

        this.retrieveControls().then(res => {
            if(!res.records) return;
            this.eowp.controlSetting = res.records;
            this.fillSettingsForUser(this.userRoleId, this.eowp.controlSetting);
        });
    },
    computed: {
            ...mapGetters({
            user: 'user/user',
            sessionDetails: 'user/session_details',
            userSession: 'user/session',
            userEmail: 'user/user'
        })
    },
    mounted(){
        let user = {
            sessionId: this.userSession,
            email: this.userEmail
        };
        this.fetchUserDetails(user).then(res => {
            this.userRoleId = res.records.roleId;
        });
    },
    methods: {
        ...mapActions({
            retrieveControls: 'control/retrieveControls',
            updateControllerStatus: 'control/updateControllerStatus',
            fetchUserDetails: 'user/fetchUserDetails',
            verifyAccess: 'user/verifyAccess',
            trackClickEvent: 'ga/trackClickEvent',
            fetchSessionDetails: 'user/fetchSessionDetails'
        }),
        showToggleLoading(id){
            return this.toggleButtonLoadingOwner == id ? 'slider-loading' : '';
        },
        toggleSetting(obj){
            this.toggleButtonLoadingOwner = obj.id;
            let params = Utils.getParameters(window.location.href);
            if(params && params.error){
                console.log("update failed 1");
                this.updateFailed = true;
                this.reloadPage();
            }
            let toggleEventName = obj.name + "_click";
            this.trackClickEvent({event: toggleEventName, path: this.$route.path, title: this.$route.meta.title});

            let controllerUpdateData = {
                id: obj.id,
                name: obj.name,
                description: obj.description,
                controlCode: obj.controlCode,
                redirect: obj.redirect,
                status: obj.status,
                updatedBy: this.user,
                userId: this.sessionDetails.userId,
                sessionId: this.sessionDetails.sessionId,
            };
            this.updateControllerStatus(controllerUpdateData).then(res => {
                if(!res.records){
                    this.updateFailed = true;
                    this.reloadPage();
                    return;
                }
                this.eowp.controlSetting = res.records;
                this.fillSettingsForUser(this.userRoleId, this.eowp.controlSetting);
            });
            setTimeout(()=>{
                this.toggleButtonLoadingOwner = '';
            },400);
        },
        fillSettingsForUser(userRole, settingsList){
            for (const key in settingsList) {
                if(settingsList[key].rolesAllowed.includes(userRole)){
                    settingsList[key].showItem = true;
                }
            }
        },
        reloadPage(){
            setTimeout(()=>{
                this.$router.go();
            },420);
        },
        verifyControlPageAccess(){
            let userData = {
                userId: this.sessionDetails.userId,
                sessionId: this.sessionDetails.sessionId,
                action: this.eowp.pageControlName
            };

            this.verifyAccess(userData).then(res => {
                if(res.status != UserModel.STATUS_SUCCESS){
                    this.$router.push("/products");
                }
            });
        }
    },
    components: { BAlert },
    mixins: [
        DialogMixin
    ]
};
</script>
